import MyRegularSupportPriceChange from './MyRegularSupportPriceChange';
import RegularAmountChangeLayerPopup, {
  RegularAmountModifyResult,
} from '../Layer/RegularAmountChangeLayerPopup';
import {
  myActiveHistoryVo,
  myMissModuleVo,
  MySupportInfoControllerService,
} from '@/__generated__/FrontApi';
import Button from '@/components/Button';
import ListSkeleton from '@/components/Mypage/ListSkeleton';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { usePopupStore } from '@/stores/PopupStore';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

const HistoryList = styled.ul``;
const HistoryItem = styled.li`
  width: 100%;
  padding: 32px 0;
  position: relative;
  border-bottom: 1px solid #b7b8ba;

  ${breakpoint(800)} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 24px 0;
  }
  ${Button} {
    max-width: none;
    width: auto;
    ${breakpoint(800)} {
      width: 100%;
    }
  }
  form {
    display: flex;
    justify-content: flex-end;
    ${breakpoint(800)} {
      display: block;
    }
  }
`;
const NoData = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  padding: 96px 16px;
  ${breakpoint(800)} {
    font-size: 16px;
  }
  ${breakpoint(640)} {
    font-size: 14px;
    padding: 72px 16px;
  }
`;
interface RegularSupportHistoryListProps {
  className?: string;
  params?: any;
  moduleInfo?: myMissModuleVo;
}

// 정기후원 컴포넌트
export const RegularSupportHistoryList: React.FC<RegularSupportHistoryListProps> = observer(
  ({ className, moduleInfo }) => {
    const popupStore = usePopupStore();
    const [items, setItems] = useState<myActiveHistoryVo[]>([]);
    const [loading, setLoading] = useState(true);
    const [
      currentModifyResult,
      setCurrentModifyResult,
    ] = useState<RegularAmountModifyResult>();

    // 정기후원내역 로드
    const loadRegularItems = useCallback(async () => {
      try {
        const {
          data,
        } = await MySupportInfoControllerService.getMySupportInfoListUsingGet({
          pathType: moduleInfo ? `MISSMODULE` : `SUPPORT`,
        });
        setItems(data as myActiveHistoryVo[]);
      } finally {
        setLoading(false);
      }
    }, [moduleInfo]);

    useEffect(() => {
      loadRegularItems();
    }, [loadRegularItems]);

    return (
      <>
        {loading && <ListSkeleton />}
        {!loading && items.length > 0 && (
          <HistoryList className={className}>
            {items.map((item) => (
              <HistoryItem
                key={`pledge_${item.pledgeId}`}
                css={`
                  position: relative;
                `}
              >
                {/* 리스트 단위 이벤트가 있어 컴포넌트 분리 */}
                <MyRegularSupportPriceChange
                  pledgeList={items}
                  pledgeInfo={item}
                  moduleInfo={moduleInfo}
                  onUpdateAmount={(updateInfo) => {
                    setCurrentModifyResult(updateInfo);
                  }}
                  onUpdatePaymethod={async () => {
                    await loadRegularItems();
                    popupStore.show('결제수단이 변경되었습니다.');
                  }}
                />
              </HistoryItem>
            ))}
            {currentModifyResult?.nextPayDay && (
              <>
                {/* 증액완료 알림 팝업 */}
                <RegularAmountChangeLayerPopup
                  result={currentModifyResult}
                  onRequestClose={() => {
                    setCurrentModifyResult(undefined);
                    loadRegularItems();
                  }}
                />
              </>
            )}
          </HistoryList>
        )}
        {!loading && items.length === 0 && (
          <NoData>후원내역이 없습니다.</NoData>
        )}
      </>
    );
  },
);

export default RegularSupportHistoryList;
